// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3vyx6","header":"ReportDetails_header__3o9zS","title":"ReportDetails_title__1UWHo","left":"ReportDetails_left__1NeCc"};